<app-header></app-header>

<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" 
         [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">{{slide.type}}</span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title" *ngIf="title!=''">{{title}}</span>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="getDevisAutre()">Obtenir un devis</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="case-studies-area">
  <div class="container">
    
    <!-- Barre de progression -->
    <div class="row" *ngIf="currentStep > 0 && currentStep < 4">
      <div class="devis">
        <div class="title">Mon devis</div>
        <img src="assets/images/stopwatch.svg" alt="">
      </div>
      <div class="temps">
        <span class="barre-temps"></span>
        <span class="message-temps">En quelques minutes</span>
      </div>
    </div>

    <!-- <div class="progress" *ngIf="currentStep > 0 && currentStep < 4">
      <div class="progress-bar progress-bar-striped progress-bar-animated" 
           [style.width.%]="getProgressPercentage()"></div>
      <span class="text-changement">{{getProgressText()}}</span>
    </div> -->

    <div class="latest-services-area">
      <div class="container">
        <div class="formulaire" *ngIf="currentStep >= 0">
          <form [formGroup]="simulationStockForm" class="form-wizard-container">
            
            <!-- Page d'accueil -->
            <div class="welcome-step" *ngIf="currentStep === 0">
              <div class="welcome-content">
                <h1>Bonjour ! Je suis Marilyne</h1>
                <h2>Je suis là pour vous aider</h2>
                <p class="welcome-description">
                  Obtenez votre devis d'assurance stock de marchandises en quelques minutes seulement.
                  Je vais vous guider étape par étape pour protéger votre stock.
                </p>
                <button class="cta-button" (click)="nextStep()">
                  C'est parti !!
                </button>
              </div>
            </div>

            <!-- Étape 1: Informations sur le stock -->
            <div class="step-container" *ngIf="currentStep === 1">
              <div class="step-header">
                <h2>Informations sur le stock</h2>
                <p class="step-subtitle">Détails de votre stock de marchandises</p>
                <div class="step-progress">Étape 1 sur 2</div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box mt-30">
                    <input type="email" formControlName="email" placeholder="Courriel *" noAutocomplete>
                    <img class="img-email" popover="Email" placement="top" triggers="mouseenter:mouseleave"
                      src="assets/images/icon-email.svg" alt="">
                    <i class="barre"></i>
                  </div>
                   <div *ngIf="simulationStockForm.get('email').errors">
                      <div
                        *ngIf="simulationStockForm.get('email').errors.required && (simulationStockForm.get('email').dirty || simulationStockForm.get('email').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                      <div *ngIf="simulationStockForm.get('email').errors.pattern">
                        <div class="text-red">
                          Email est invalide
                        </div>
                      </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box sinistre mt-30">
                    <input type="tel" 
                           formControlName="telephone"
                           ng2TelInput 
                           [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                           placeholder="Numéro de téléphone *"
                           (focus)="isFocus=true" 
                           (blur)="isFocus=false; hasError($event, 'telephone', 'simulationStockForm');autoSave()"
                           (ng2TelOutput)="getNumber($event, 'telephone', 'simulationStockForm')"
                           (intlTelInputObject)="telInputObject($event)" 
                           (countryChange)="onCountryChange($event)" noAutocomplete>
                  </div>
                  <div *ngIf="simulationStockForm.get('telephone').errors">
                      <div
                        *ngIf="simulationStockForm.get('telephone').errors.required && (simulationStockForm.get('telephone').dirty || simulationStockForm.get('telephone').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                  </div>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box mt-30">
                  <input type="text" formControlName="adresse" placeholder="Localisation du magasin">
                  <img class="img-form" popover="Localisation du magasin" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/icon-adresse.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box mt-30">
                  <input type="text" formControlName="ville" placeholder="Ville" noAutocomplete>
                  <img class="img-form" popover="Ville" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/icon-adresse.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" 
                         formControlName="dateEffet"
                         bsDatepicker
                         [minDate]="newDate"
                         [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                         placeholder="Date d'effet"
                         (bsValueChange)="updateMinDates()">
                  <span class="input-icon">
                    <img src="assets/images/icon-date.svg" alt="">
                  </span>
                </div>
                </div>
                
                 <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <ng-select formControlName="duree" 
                            clearAllText="Effacer tout" 
                            notFoundText="Aucun élément trouvé"
                            [items]="listDuree" 
                            bindLabel="name" 
                            bindValue="value"
                            placeholder="Durée">
                  </ng-select>
                  <span class="input-icon">
                    <img src="assets/images/duree.svg" alt="">
                  </span>
                </div>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box mt-30">
                  <input type="text" formControlName="valeurStock" placeholder="Valeur du stock">
                  <img class="img-form" popover="Valeur du stock" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/icon-valeur-locative.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box mt-30">
                  <input type="text" formControlName="typeMarchandises" placeholder="Type de marchandises">
                  <img class="img-form" popover="Type de marchandises" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/icon-fonction.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="currentStep = 0">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 2: Informations de l'entreprise -->
            <div class="step-container" *ngIf="currentStep === 2">
              <div class="step-header">
                <h2>Informations de l'entreprise</h2>
                <p class="step-subtitle">Détails sur votre entreprise</p>
                <div class="step-progress">Étape 2 sur 2</div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box mt-30">
                  <input type="text" formControlName="nom" placeholder="Nom de l'entreprise">
                  <img class="img-form" popover="Nom de l'entreprise" placement="top" triggers="mouseenter:mouseleave"
                    src="assets/images/nom.svg" alt="">
                  <i class="barre"></i>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" 
                         formControlName="dateNaiss"
                         bsDatepicker
                         [maxDate]="newDate"
                         [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                         placeholder="Date de naissance">
                  <span class="input-icon">
                    <img src="assets/images/icon-date.svg" alt="">
                  </span>
                </div>
                </div>
              </div>

              <div class="formulaire">
                 <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Sexe</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let sexe of listTypeSexe">
                      <input type="radio" [id]="sexe.value" [value]="sexe.value" formControlName="sexe" />
                      <label [for]="sexe.value">{{sexe.name}}</label>
                    </div>
                  </div>
                </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Voir le récapitulatif</button>
              </div>
            </div>

            <!-- Récapitulatif -->
            <div class="step-container_2" *ngIf="currentStep === 3">
              <div class="step-header">
                <h2>Récapitulatif de votre demande d'assurance stock</h2>
                <p class="step-subtitle">Vérifiez vos informations avant de finaliser</p>
              </div>

              <div class="recap-form-container">
                <div class="mesImage">
                  <div class="imgLogo">
                    <img src="assets/images/logo.png" alt="Logo Inclusive Guarantee">
                  </div>
                </div>
                
                <div class="info-devis">
                  <div class="proposition">
                    <div class="pro-title">Demande d'assurance stock de marchandises</div>
                    <div class="sub-title">{{numeroSous}}</div>
                  </div>
                  
                  <div class="row">
                    <!-- Informations de l'entreprise -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations de l'entreprise</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro</div>
                            <div class="col-7 value">{{numeroSous}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Nom de l'entreprise</div>
                            <div class="col-7 value">{{simulationStockForm?.get('nom')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date de naissance</div>
                            <div class="col-7 value">{{simulationStockForm?.get('dateNaiss')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Sexe</div>
                            <div class="col-7 value">{{simulationStockForm?.get('sexe')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date de demande</div>
                            <div class="col-7 value">{{newDate | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Email</div>
                            <div class="col-7 value">{{simulationStockForm?.get('email')?.value || 'Non renseigné'}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Téléphone</div>
                            <div class="col-7 value">{{simulationStockForm?.get('telephone')?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Informations sur le stock -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations sur le stock</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro stock</div>
                            <div class="col-7 value">{{refPro}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Localisation</div>
                            <div class="col-7 value">{{simulationStockForm?.get('adresse')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Ville</div>
                            <div class="col-7 value">{{simulationStockForm?.get('ville')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date d'effet</div>
                            <div class="col-7 value">{{simulationStockForm?.get('dateEffet')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Durée</div>
                            <div class="col-7 value">{{simulationStockForm?.get('duree')?.value}} mois</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Valeur du stock</div>
                            <div class="col-7 value">{{simulationStockForm?.get('valeurStock')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Type de marchandises</div>
                            <div class="col-7 value">{{simulationStockForm?.get('typeMarchandises')?.value}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="description-ass">
                    Cette demande d'assurance stock de marchandises sera traitée par nos équipes dans les plus brefs délais. 
                    Vous recevrez une confirmation par email avec les détails de votre couverture.
                  </div>
                  
                  <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Demande d'assurance stock de marchandises
                    </div>
                    <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Date émission : {{newDate | date:'dd/MM/yyyy'}} - E-MAIL : contact&#64;inclusiveguarantee.fr
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  <!-- <i class="fa fa-arrow-left"></i> -->
                  Retour
                </button>
                <button type="button" class="btn-continue final-btn" [disabled]="sendingRequest" (click)="saveData()">
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                  <span *ngIf="!sendingRequest">Finaliser la souscription</span>
                  <span *ngIf="sendingRequest">Traitement en cours...</span>
                </button>
              </div>
            </div>

             <!-- Étape succès -->
            <div class="step-container" *ngIf="currentStep === 4">
              <div class="success-auto">
                <div class="icon-succes">
                   <img width="10%" src="/assets/images/verifier.png" alt="" srcset="">
                </div>
                <!-- <div class="message-success">
                  Votre demande d'assurance stock de marchandises a été enregistrée avec succès !
                  <span>Numéro de référence : {{numeroSous}}</span>
                  <span>Nos équipes vous contacteront dans les plus brefs délais.</span>
                </div> -->
                <div class="message-success">
                  Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
                  <span>L'équipe d'Inclusive Guarantee</span>
                </div>
                <button class="btn-success" (click)="resetForm()">
                  <span>Nouvelle demande</span>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>